import { useParams } from 'react-router';

import { DatasourceTab } from '@/modules/collections/types';

export const useTabCategory = () => {
  const { category } = useParams<{ category: DatasourceTab }>();

  return {
    isFAQTab: category === 'faq',
    isDocumentsTab: category === 'documents',
    isWebsiteTab: category === 'webpages',
    isExternalTab: category === 'external',
    category,
  };
};
